import styled from 'styled-components';

export const Wrapper = styled.div`
user-select: none;
`;
Wrapper.displayName = 'Wrapper';

export const VulnsWrapper = styled.div`
  user-select: none;
  height: 118px;
  overflow-y: auto;
  >:nth-child(n){
    padding: 0 10px;
  }
  >:not(:last-child) {
    border-bottom: ${({ theme }) => `solid 1px ${theme.borders.tableItem}`};
  }
  background: ${({ showGradient, theme }) =>
        showGradient
            ? `linear-gradient(
                to bottom,
                ${theme.backgrounds.modal} 0%,       
                ${theme.backgrounds.modal} 33.33%,  
                ${theme.backgrounds.modal4} 33.33%,   
                ${theme.backgrounds.modal4} 66.66%,   
                ${theme.backgrounds.modal} 66.66%,  
                ${theme.backgrounds.modal} 100%
            )`
            : theme.backgrounds.modal};
  box-shadow: ${({ $hideListShadow, theme }) =>
    $hideListShadow ? 'none' : `0 2px 50px 0 ${theme.textfield.background}`};
`;
VulnsWrapper.displayName = 'VulnsWrapper';

export const AddWrapper = styled.div`
  margin-bottom: 10px;
`;
AddWrapper.displayName = 'AddWrapper';

export const Label = styled.div`
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.44;
  color: ${({ theme }) => theme.text.detailModalFields} !important;
  margin-bottom: 8px;
  user-select: none;
`;
Label.displayName = 'Label';

export const dropdownStyle = (theme) => ({
  control: (provided, { isDisabled }) => ({
    display: 'flex',
    minHeight: '35px',
    backgroundColor: isDisabled ? theme.buttons.disabled.background : theme.textfield.background,
    color: isDisabled ? theme.text.disabled : theme.textfield.text,
    paddingLeft: '10px',
    fontWeight: '700',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
    boxShadow: theme.shadows.agentSelectorInScheduler
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  placeholder: (provided, { isDisabled }) => ({
    ...provided,
    fontSize: '12.5px',
    color: theme.text.placeholder,
    fontWeight: 400
  }),
  input: (provided) => ({
    ...provided,
    fontSize: '13px',
    color: theme.textfield.text,
    fontWeight: 300
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#505965',
    width: '30px'
  }),
  option: (provided, { isFocused }) => ({
    ...provided,
    backgroundColor: isFocused ? theme.backgrounds.actionDropDownHover : theme.backgrounds.actionDropDown,
    fontSize: '13.5px',
    textAlign: 'left',
    color: theme.text.actionDropDownItem,
    cursor: isFocused ? 'pointer' : 'default',
    paddingLeft: '22px',
    paddingRight: '22px',
    height: '36px',
    textTransform: 'none',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }),
  valueContainer: () => ({
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    marginRight: 'auto'
  }),
  menu: () => ({
    position: 'absolute',
    marginTop: '6px',
    zIndex: 5000,
    width: '100%',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.dropdown1Options,
    boxShadow: `2px 2px 30px 0 ${theme.shadows.actionDropDown}`,
    minWidth: '190px'
  }),
  menuList: () => ({
    maxHeight: '152px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '10px',
    paddingBottom: '13px'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return {
      ...provided, opacity, transition, color: theme.text.actionDropDownTitle, width: 'fit-content', height: '19px', fontSize: '14px', fontWeight: 400, top: '8px', position: 'relative'
    };
  }
});
